require("./components/min");
require("../html-components/calendarReminder");

window.Vue = require("vue");

Vue.component("tz-time", require("../components/TzTime.vue").default);

Vue.component(
  "starts-in-badge",
  require("../components/StartsInBadge.vue").default
);

new Vue({ el: "#app" });

document.addEventListener("DOMContentLoaded", () => {
  const controlNext = document.getElementById("streams-control-next");
  const controlPrev = document.getElementById("streams-control-prev");
  console.log("init");

  controlNext.addEventListener("click", () => {
    console.log("next");
    const offset = 42;
    // 42 px is the gap

    const sliderContent = document.getElementById("streams-content");
    sliderContent.scroll(
      sliderContent.scrollLeft + sliderContent.clientWidth + offset,
      0
    );
  });

  controlPrev.addEventListener("click", () => {
    console.log("prev");
    const offset = window.innerWidth < 500 ? 42 : 44;
    const sliderContent = document.getElementById("streams-content");
    sliderContent.scroll(
      sliderContent.scrollLeft + -sliderContent.clientWidth - offset,
      0
    );
  });
});

function Marquee(selector, speed) {
  const parentSelector = document.querySelector(selector);
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;
  // console.log(firstElement);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);
  parentSelector.insertAdjacentHTML("beforeend", clone);

  setInterval(function() {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}

//after window is completed load
//1 class selector for marquee
//2 marquee speed 0.2
window.addEventListener("load", Marquee(".marquee", 0.2));
